<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents" v-if="!isRendering">
      <h1 class="l-pageTitle"><img src="@/assets/img/common/icon-nav3_blue.svg" alt="">お知らせ</h1>
      <div class="l-btn-createnew_pos">
        <div v-if="isSystemAdmin || isAdmin" class="btn-create-new_wh" @click="goInput('')" :disabled="isProcessing"><a>新規作成</a></div>
      </div>
      <div class="l-contentsBox">
        <div class="l-diagnosisSearch">
          <div class="l-diagnosisSearch__header" @click="showSearch(!isSearch)">
            <p class="l-diagnosisSearch__label"><img src="@/assets/img/common/icon-search.svg" alt="">絞り込み</p>
            <div class="l-diagnosisSearch__selected">
              <dl>
                <dt>検索条件</dt>
                <dd>{{ selectedNoticeTypeLabel }}</dd>
              </dl>
            </div>
          </div>
          <transition name="noticesearch-fade" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
            <div class="l-diagnosisSearch__body" v-show="isSearch">
              <div class="l-diagnosisSearch__section">
                <label class="l-formGroup__label">カテゴリ</label>
                <ul class="l-inputList">
                  <li v-for="noticeType in selectNoticeTypeList" :key="noticeType.noticeId">
                    <label class="l-checkbox">
                      <input type="checkbox"
                        :value="noticeType.value"
                        v-model="searchForm.noticeTypes" />
                      {{ noticeType.label }}
                    </label>
                  </li>
                </ul>
              </div>
              <div class="l-diagnosisSearch__section">
                <label class="l-formGroup__label">キーワード</label>
                <div class="l-inputKeyword">
                  <TextBox v-model="searchForm.searchText" placeholder="" name="searchText" ></TextBox>
                </div>
              </div>
              <div class="l-diagnosisSearch__bottom">
                <div class="btn-basic is-inlne" @click="getNoticeList(1)" :disabled="isProcessing"><a>絞り込む</a></div>
              </div>
            </div>
          </transition>
        </div>

        <div class="l-grayBox mt-30">
          <div class="l-infoResult">
            <p><span>検索結果：</span>{{ pageInfo.total }}件</p>
          </div>
        </div>
        <table class="table-base audit-table table-select mt-30">
          <colgroup>
            <col style="width: 120px;">
            <col style="width: 100px;">
            <col style="width: 500px;">
            <col style="width: 150px;">
            <col>
            <col>
          </colgroup>
          <thead>
            <th>掲載日</th>
            <th class="t-center">カテゴリ</th>
            <th>タイトル</th>
            <th class="t-center">添付ファイル</th>
            <th></th>
          </thead>
          <tbody>
            <tr v-for="notice in noticeList" :key="notice.noticeId">
              <td @click="goDetail(notice.noticeId)">{{ $dayjs(notice.fromDt).format("YYYY/MM/DD") }}</td>
              <td class="t-center" @click="goDetail(notice.noticeId)"><span class="info-catlabel">{{ noticeTypeName(notice) }}</span></td>
              <td @click="goDetail(notice.noticeId)">{{ notice.title }}</td>
              <td class="t-center" @click="goDetail(notice.noticeId)">
                <img v-if="notice.file" src="@/assets/img/common/icon-attch_on.svg" alt="" width="18" height="18">
              </td>
              <td @click="goDetail(notice.noticeId)">
                <span v-if="notice.isNew" class="info-newlabel">NEW</span>
              </td>
              <td>
                <button v-if="notice.editable" class="link-arrow" @click="goEdit(notice.noticeId)">編集</button>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination
          :pageInfo="pageInfo"
          @change-page="emitChangePage">
        </pagination>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import Pagination from '@/components/parts/common/Pagination.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import constant from '@/const';

export default {
  components: {
    Loading,
    Pagination,
    TextBox,
  },
  data() {
    return {
      pageInfo: {},
      isProcessing: false,
      isRendering: false,
      isSearch: false,
      noticeList: [
        {
          file: {
            fileId: null
          }
        }
      ],
      searchForm: {
        noticeTypes: [],
        searchText: '',
      },
      selectNoticeTypeList: constant.NOTICE_TYPE,
      isAdmin: false,
      isSystemAdmin: false,
      isAllPermission: false,
    }
  },
  computed: {
    noticeTypeName : () => (notice) => {
      let noticeType = constant.NOTICE_TYPE.find(function(element) {
        return element.value === notice.noticeType;
      });
      if (!noticeType) return '';
      return noticeType.label;
    },
    mailSendName : () => (notice) => {
      let mailSendKbn = constant.MAIL_SEND_KBN.find(function(element) {
        return element.value === notice.mailSendKbn;
      });
      return mailSendKbn.shortLabel;
    },
    selectedNoticeTypeLabel() {
      if (this.searchForm.noticeTypes.length == 0) {
        return '設定無し';
      }
      let selectNoticeTypeList = this.selectNoticeTypeList;
      let selectedNoticeTypes = [];
      this.searchForm.noticeTypes.forEach(noticeTypeId => {
        let selectedNoticeType = selectNoticeTypeList.find(noticeType => noticeType.value === noticeTypeId);
        selectedNoticeTypes.push(selectedNoticeType.label);
      }, selectNoticeTypeList)
      return selectedNoticeTypes.join(',');
    },
  },
  created: async function() {
    await this.getNoticeList(1);
    const authority = await this.$store.dispatch('auth/getAuthority')
    this.isAdmin = authority.isAdmin;
    this.isSystemAdmin = authority.isSystemAdmin;
  },
  methods: {
    showSearch(value) {
      this.isSearch = value;
    },
    emitChangePage(page) {
      this.getNoticeList(page)
    },
    async getNoticeList(page) {
      this.isProcessing = true;
      this.isRendering = true;
      let res = await this.$axios.post('/ld/api/notice/getNoticeList', {
        page: page,
        noticeTypes: this.searchForm.noticeTypes,
        searchText: this.searchForm.searchText,
        deleteFlg: false,
      });
      if (res) {
        this.noticeList = res.data.noticeList.data;
        this.pageInfo = {
          currentPage: res.data.noticeList.current_page,
          lastPage: res.data.noticeList.last_page,
          total: res.data.noticeList.total,
          from: res.data.noticeList.from,
          to: res.data.noticeList.to,
        }
        this.isSearch = false;
      }
      this.$nextTick(() => {
        this.isRendering = false;
        this.isProcessing = false;
      });
    },
    goInput() {
      this.$store.dispatch('portal/setNoticeId', null);
      this.$router.push({ name: 'notice-new' });
    },
    goEdit(noticeId) {
      this.$store.dispatch('portal/setNoticeId', noticeId);
      this.$router.push({ name: 'notice-edit' });
    },
    goDetail(noticeId) {
      this.$store.dispatch('portal/setNoticeId', noticeId);
      this.$router.push({ name: 'notice-detail', query: { noticeId: noticeId } });
    },
    beforeEnter: function(el) {
      el.style.height = '0';
    },
    enter: function(el) {
      let height = el.scrollHeight + 5;
      el.style.height = height + 'px';
    },
    beforeLeave: function(el) {
      let height = el.scrollHeight + 5;
      el.style.height = height + 'px';
    },
    leave: function(el) {
      el.style.height = '0';
    }
  },
}

</script>

<style scoped>
.noticesearch-fade-enter-active {
  transition: height .1s ease-in-out;
}
.noticesearch-fade-leave-active {
  transition: height .1s ease-in-out;
}
.noticesearch-fade-enter-to, .noticesearch-fade-leave {
  overflow: hidden;
}

.noticesearch-fade-enter, .noticesearch-fade-leave-to {
  overflow: hidden;
}
</style>
